export enum TargetType{
    FRAMESHAPE,
    FRAMETONE,
    FRAME
}